import { render, staticRenderFns } from "./OnboardingEmailAndBarcode.vue?vue&type=template&id=1d8c2274&"
import script from "./OnboardingEmailAndBarcode.vue?vue&type=script&lang=js&"
export * from "./OnboardingEmailAndBarcode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports